export default __webpack_public_path__ + "static/media/pic2.b5c54776.svg";